import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from 'src/app/global/global';
import { Friend } from 'src/app/models/friend.model';

@Injectable({
  providedIn: 'root'
})
export class FriendService {


  constructor(
    private httpClient: HttpClient
  ) { }

  getFriendsList() {
    return this.httpClient.get<Friend[]>(Global.BASE_API_URL + "/api/friends");
  }


  findFriend() {
    return this.httpClient.put<Friend>(Global.BASE_API_URL + "/api/friends/findnew", {});
  }

  deleteFriend(id: string){
    return this.httpClient.delete<Friend[]>(Global.BASE_API_URL + "/api/friends/" + id);
  }

}
